'use client'

import { useState, useEffect } from 'react'
import StepIndicator from './steps'
import Header from '../sections/header'

interface PaymentBookingProps {
  hotelId: string
  arrivalDate: string
  departureDate: string
  timeIn: string
  timeOut: string
  nights: number
  totalRooms: number
  totalAmount: number
  totalChild?: number
  totalAdult?: number
  onBackToSearch: () => void
}

export default function PaymentBooking({
  hotelId,
  arrivalDate,
  departureDate,
  timeIn,
  timeOut,
  nights,
  totalRooms,
  totalAmount,
  onBackToSearch,
}: PaymentBookingProps) {
  const today = new Date()
  const tomorrow = new Date(today)
  tomorrow.setDate(tomorrow.getDate() + 1)
  const [dataPayment, setDataPayment] = useState(null)

  useEffect(() => {
    // Restore payment data
    const savedPaymentData = sessionStorage.getItem('payment_data')
    if (savedPaymentData) {
      setDataPayment(JSON.parse(savedPaymentData))
    }
  }, [])

  useEffect(() => {
    // Save payment data
    if (dataPayment) {
      sessionStorage.setItem('payment_data', JSON.stringify(dataPayment))
    }
  }, [dataPayment])

  return (
    <>
      <Header />
      <div className="h-[calc(100vh-137px)] bg-[#F3F3F3] pb-24 md:mx-auto md:h-[calc(100vh-81px)]">
        <StepIndicator
          hotelId={hotelId}
          arrivalDate={arrivalDate}
          departureDate={departureDate}
          onBackToSearch={onBackToSearch}
          timeIn={timeIn}
          timeOut={timeOut}
          nights={nights}
          totalRooms={totalRooms}
          totalAmount={totalAmount}
        />
      </div>
    </>
  )
}
